var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import LoginModule from '../Components/LoginModule';
import { countryNavData, examNavData, firstLevelNavList } from '../constant';
import MainNavButton from './MainNavButton';
import SubNavModal from './SubNavModal';
var MainNavModal = function (_a) {
    var _b, _c;
    var isModalOpen = _a.isModalOpen, loginFunction = _a.loginFunction;
    var _d = __read(useState(null), 2), selectedKey = _d[0], setSelectedKey = _d[1];
    return (React.createElement("div", { className: "!lfc-bg-white lfc-fixed lfc-z-[900] lfc-top-[60px] lfc-left-0 lfc-right-0 lfc-bottom-0 lfc-flex lfc-flex-col lfc-w-full ".concat(isModalOpen ? 'lfc-block lfc-overflow-y-scroll' : 'lfc-hidden') },
        React.createElement(MainNavButton, { firstLevelNavList: firstLevelNavList, setSelectedKey: setSelectedKey }),
        React.createElement("div", { className: "lfc-px-4 lfc-py-5" },
            React.createElement(LoginModule, { loginFunction: loginFunction })), (_b = Object.keys(countryNavData)) === null || _b === void 0 ? void 0 :
        _b.map(function (elem, index) {
            var _a, _b, _c;
            return (React.createElement(SubNavModal, { isSubModalOpen: selectedKey === ((_a = countryNavData[elem]) === null || _a === void 0 ? void 0 : _a.uniqueId), key: "".concat((_b = countryNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId, "_").concat(index), currentKey: "".concat((_c = countryNavData[elem]) === null || _c === void 0 ? void 0 : _c.uniqueId), secondLevelNavData: countryNavData[elem], setSelectedKey: setSelectedKey }));
        }), (_c = Object.keys(examNavData)) === null || _c === void 0 ? void 0 :
        _c.map(function (elem, index) {
            var _a, _b, _c;
            return (React.createElement(SubNavModal, { isSubModalOpen: selectedKey === ((_a = examNavData[elem]) === null || _a === void 0 ? void 0 : _a.uniqueId), key: "".concat((_b = examNavData[elem]) === null || _b === void 0 ? void 0 : _b.uniqueId, "_").concat(index), currentKey: "".concat((_c = examNavData[elem]) === null || _c === void 0 ? void 0 : _c.uniqueId), secondLevelNavData: examNavData[elem], setSelectedKey: setSelectedKey }));
        })));
};
export default MainNavModal;
//# sourceMappingURL=MainNavModal.js.map